import React, { Component } from 'react';

export class DecimalCellEditor extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef();
    }

    onKeyPress(event) {
        if (!isNumeric(event.nativeEvent)) {
            event.preventDefault();
        }

        function isNumeric(event) {
            return /^[+-]?\d*(?:[.,]\d*)?$/.test(event.key);
        }
    }

    onKeyDown(event) {
        if (event.keyCode === 39 || event.keyCode === 37) {
            event.stopPropagation();
        }
    }

    afterGuiAttached() {
        if (this.textInput) this.textInput.current.focus();
    };

    getValue() {
        return this.textInput.current.value;
    };

    componentDidMount() {
        this.textInput.current.addEventListener('keydown', this.onKeyDown);
    }

    render() {
        return (
            <input className="celleditorheight" onKeyPress={this.onKeyPress}
            onChange={(e) => {
                //this.props.node.setDataValue(this.props.colDef.field, selected.label);
                //this.props.node.setDataValue(this.props.colDef.field + "_Id", selected.value);
                this.props.node.setDataValue(this.props.colDef.field, e.target.value);

            }}
             ref={this.textInput} defaultValue={this.props.value}/>
        );
    }
}